import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDSnackbar from "components/MDSnackbar";
import styled from "styled-components";
import DatePicker from "react-multi-date-picker";
import { CircularProgress, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import GraficoMeta from "./alocação/tipo-ativo/graficos";
import { name } from "dayjs/locale/pt-br";
import AlocacaoPorAtivo from "./alocação/por-ativo/graficos";
import KeepMountedModal from "components/Modal";
import FormMetaAlocacao from "./alocação/meta/formMetaAlocacao";
import { getAllocationTarget, getCurrentAllocation } from "./alocação/api/allocationApi";
import { Link, Navigate } from "react-router-dom";
import { useMaterialUIController } from "context";
import { buildAuthRoute, buildPaymentRoute } from "utils/checkoutFlow";
import { APP_REBALANCE_SCORE_ROUTE, SIGN_UP_ROUTE } from "utils/routes";

const PRO_TIER = 3;

function RebalancearCarteira() {
    const hasAuthToken =
        typeof window !== "undefined" && Boolean(window.localStorage.getItem("tradez-token"));
    const [controller, dispatch] = useMaterialUIController();
    const {
        userTier
    } = controller;
    const [successSB, setSuccessSB] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [allocationTarget, setAllocationTarget] = useState([]);
    const [currentAllocationTarget, setCurrentAllocationTarget] = useState([]);
    const [openSnackMessage, setOpenSnackMessage] = useState(null);

    useEffect(() => {
        getAssetsTypeAllocationTarget();
        getCurrentAssetsTypeAllocation();
    }, [])

    const getAssetsTypeAllocationTarget = async () => {
        setIsLoading(true);

        await getAllocationTarget()
            .then((data) => {
                setIsLoading(false);
                if (data?.errorCode) {
                    // openSnackBar({ type: 'error', message: `${data?.message}` });
                    return;
                }

                setAllocationTarget(data);

                // openSnackBar({ type: 'success', message: 'Operação realizada com sucesso' });
                // closeModal();
                // resetForm();
                // refreshList();
                // refreshSummaryBoxes();
            })
            .catch(e => {
                // openSnackBar({ type: 'error', message: `${e}` });
            });
    };

    const getCurrentAssetsTypeAllocation = async () => {
        setIsLoading(true);

        await getCurrentAllocation()
            .then((data) => {
                setIsLoading(false);
                if (data?.errorCode) {
                    // openSnackBar({ type: 'error', message: `${data?.message}` });
                    return;
                }

                setCurrentAllocationTarget(data);

                // openSnackBar({ type: 'success', message: 'Operação realizada com sucesso' });
                // closeModal();
                // resetForm();
                // refreshList();
                // refreshSummaryBoxes();
            })
            .catch(e => {
                // openSnackBar({ type: 'error', message: `${e}` });
            });
    };

    const handleCloseModal = () => {
        setIsOpen(false);
    };

    if (Number(userTier ?? 1) < PRO_TIER){
       return (
        <Navigate
            to={
                hasAuthToken
                    ? buildPaymentRoute("pro")
                    : buildAuthRoute(SIGN_UP_ROUTE, "pro", { upgradeNow: 1 })
            }
            replace
        />
       )
    }


        return (
            <DashboardLayout>
                <DashboardNavbar />
                <Grid item xs={12} sm={6} lg={3}>
                    <MDSnackbar
                        // color={openSnackMessage?.type}
                        icon="check"
                    // title={openSnackMessage?.message}
                    // content="Hello, world! This is a notification message"
                    // dateTime="11 mins ago"
                    // open={openSnackMessage}
                    // onClose={() => setOpenSnackMessage(false)}
                    // close={() => setOpenSnackMessage(false)}
                    // bgWhite
                    />
                </Grid>
                <MDBox pt={{ xs: 4, md: 6 }} pb={3}>
                    <Grid container spacing={{ xs: 3, md: 6 }}>
                        <Grid item xs={12}>
                            <Card>
                                <StyledMDBox
                                    mx={{ xs: 1.5, sm: 2 }}
                                    mt={{ xs: -2, sm: -3 }}
                                    py={{ xs: 2.25, sm: 3 }}
                                    px={{ xs: 2, sm: 2 }}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="dark">
                                        Exposição por tipo de ativo
                                    </MDTypography>
                                </StyledMDBox>

                                <StyledDiv>
                                    <MDBox pt={{ xs: 3, md: 4 }} pb={{ xs: 2, md: 3 }} px={{ xs: 2, md: 1 }} className="grafic">
                                        <ChartHeader>
                                            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                                                Exposição atual
                                            </MDTypography>
                                            <MDTypography variant="button" color="text" display="block">
                                                Compare a exposição atual por classe com a meta desejada para reduzir desvios e concentração.
                                            </MDTypography>
                                        </ChartHeader>
                                        <GraficoMeta data={currentAllocationTarget} />
                                    </MDBox>

                                    <MDBox pt={{ xs: 2, md: 4 }} pb={{ xs: 3, md: 3 }} px={{ xs: 2, md: 1 }} className="grafic">
                                        <ChartHeader>
                                            <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                                                Meta de exposição
                                            </MDTypography>
                                        </ChartHeader>
                                        <GraficoMeta data={allocationTarget} />

                                        <MDButton
                                            variant="gradient"
                                            color="info"
                                            onClick={() => setIsOpen(!isOpen)}
                                            sx={{ width: { xs: "100%", sm: "auto" }, maxWidth: { xs: 320, sm: "none" } }}
                                        >
                                            Editar meta
                                        </MDButton>
                                        <KeepMountedModal
                                            isOpen={isOpen}
                                            closeModal={handleCloseModal}
                                            content={<FormMetaAlocacao
                                                title="Configuração da meta de exposição"
                                                refreshGraph={getAssetsTypeAllocationTarget}
                                                currentData={allocationTarget}
                                                openSnackBar={(e) => setOpenSnackMessage(e)}
                                                closeModal={handleCloseModal}
                                            />}
                                        />
                                    </MDBox>
                                </StyledDiv>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                <MDBox pt={{ xs: 3, md: 6 }} pb={3}>
                    <Grid container spacing={{ xs: 3, md: 6 }}>
                        <Grid item xs={12}>
                            <Card>
                                <StyledMDBox
                                    mx={{ xs: 1.5, sm: 2 }}
                                    mt={{ xs: -2, sm: -3 }}
                                    py={{ xs: 2.25, sm: 3 }}
                                    px={{ xs: 2, sm: 2 }}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                >
                                    <MDTypography variant="h6" color="dark">
                                        Exposição por ativo
                                    </MDTypography>
                                </StyledMDBox>

                                <StyledDiv>
                                    <MDBox pt={{ xs: 3, md: 4 }} pb={{ xs: 2, md: 3 }} px={{ xs: 2, md: 3 }} className="grafic">
                                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                                            Meta de exposição
                                        </MDTypography>
                                        <MDTypography variant="button" color="text" display="block">
                                            Entenda onde cada ativo está acima ou abaixo do peso desejado dentro da carteira.
                                        </MDTypography>
                                        <AlocacaoPorAtivo />
                                    </MDBox>
                                </StyledDiv>
                                <StyledDivButton>
                                    <Link to={APP_REBALANCE_SCORE_ROUTE}>

                                        <MDButton
                                            variant="gradient"
                                            color="info"
                                            sx={{ width: { xs: "100%", sm: "auto" }, maxWidth: { xs: 320, sm: "none" } }}
                                        // onClick={() => setIsOpen(!isOpen)}
                                        >
                                            Definir peso por ativo
                                        </MDButton>
                                    </Link>
                                </StyledDivButton>

                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                <Footer />

                <Grid item xs={12} sm={6} lg={3}>
                    <MDSnackbar
                        color={openSnackMessage?.type}
                        icon="check"
                        title={openSnackMessage?.message}
                        open={openSnackMessage}
                        onClose={() => setOpenSnackMessage(false)}
                        close={() => setOpenSnackMessage(false)}
                    // bgWhite
                    />
                </Grid>
            </DashboardLayout>
        );
}

const StyledMDBox = styled(MDBox)`
  background: radial-gradient(circle at 221% 201%, #f28371 0%, #f28371 65%, transparent 0%) ,#f0ba8d !important; 
`;

const StyledDiv = styled.div`
    display: flex;
    justify-content: space-around;
    gap: 16px;

    .grafic{
        width: 100%;
        min-width: 0;
        display:flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    @media (max-width: 900px) {
        flex-direction: column;
        gap: 0;
    }
`;

const ChartHeader = styled.div`
    display: flex;
    min-height: 92px;
    max-width: 44rem;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    @media (max-width: 900px) {
        min-height: 0;
    }
`;

const StyledDivButton = styled.div`
    display: flex;
    justify-content: center;
    padding: 0 24px 25px;

    a {
        display: inline-flex;
        justify-content: center;
        width: auto;
        text-decoration: none;
    }

    @media (max-width: 600px) {
        padding: 0 16px 24px;

        a {
            width: 100%;
            max-width: 320px;
        }
    }
`;

export default RebalancearCarteira;
